import React from 'react';
import { VabysmoLanding } from './pages/VabysmoLanding';
export function App() {
  return <VabysmoLanding data-id="element-0" />;
}